"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStrategyMatrixQueryState = void 0;
const strategy_matrix_query_params_models_1 = require("./strategy-matrix-query-params.models");
const hasAllChildrenSelected = (categoryId, selectedChildren, allChildIdsByCategoryId) => {
    var _a;
    const allChildIds = (_a = allChildIdsByCategoryId[categoryId]) !== null && _a !== void 0 ? _a : [];
    if (!allChildIds.length)
        return false;
    if (selectedChildren.length !== allChildIds.length)
        return false;
    const selectedChildrenSet = new Set(selectedChildren);
    return allChildIds.every((id) => selectedChildrenSet.has(id));
};
const getNormalizedFilterForL1Compaction = (extendedFilter, allChildIdsByCategoryId) => (extendedFilter.map((category) => {
    var _a;
    if (!((_a = category.children) === null || _a === void 0 ? void 0 : _a.length)) {
        return category;
    }
    if (!hasAllChildrenSelected(category.id, category.children, allChildIdsByCategoryId)) {
        return category;
    }
    return { id: category.id };
}));
const getCompactFilterState = (extendedFilter, allChildIdsByCategoryId, allCategoryIds = []) => {
    const normalizedExtendedFilter = getNormalizedFilterForL1Compaction(extendedFilter, allChildIdsByCategoryId);
    if (!allCategoryIds.length)
        return null;
    if (!normalizedExtendedFilter.length) {
        return {
            selectAll: true,
            excludedValues: [],
        };
    }
    const selectedCategoryIds = normalizedExtendedFilter.map(({ id }) => id);
    if (selectedCategoryIds.length < allCategoryIds.length / 2)
        return null;
    const selectedCategoryIdsSet = new Set(selectedCategoryIds);
    const excludedValues = allCategoryIds.filter((id) => !selectedCategoryIdsSet.has(id));
    const categories = normalizedExtendedFilter
        .filter((category) => { var _a; return (_a = category.children) === null || _a === void 0 ? void 0 : _a.length; })
        .map((category) => {
        var _a;
        const selectedChildren = (_a = category.children) !== null && _a !== void 0 ? _a : [];
        const compactChildren = getCompactChildrenState(category.id, selectedChildren, allChildIdsByCategoryId);
        if (compactChildren) {
            return {
                id: category.id,
                children: compactChildren,
            };
        }
        return {
            id: category.id,
            children: selectedChildren,
        };
    });
    return Object.assign({ selectAll: true, excludedValues }, (categories.length ? { categories } : {}));
};
const getCompactChildrenState = (categoryId, selectedChildren, allChildIdsByCategoryId, options = {}) => {
    var _a;
    const allChildIds = (_a = allChildIdsByCategoryId[categoryId]) !== null && _a !== void 0 ? _a : [];
    if (!allChildIds.length || selectedChildren.length < allChildIds.length / 2) {
        return null;
    }
    const selectedChildrenSet = new Set(selectedChildren);
    const excludedValues = allChildIds.filter((id) => !selectedChildrenSet.has(id));
    if (!excludedValues.length && !options.allowEmptyExclusions) {
        return null;
    }
    return {
        selectAll: true,
        excludedValues,
    };
};
const getExtendedFilterWithCompactChildren = (extendedFilter, allChildIdsByCategoryId) => (extendedFilter.map((category) => {
    var _a;
    const selectedChildren = category.children;
    if (!(selectedChildren === null || selectedChildren === void 0 ? void 0 : selectedChildren.length)) {
        return { id: category.id };
    }
    const compactChildren = (_a = getCompactChildrenState(category.id, selectedChildren, allChildIdsByCategoryId)) !== null && _a !== void 0 ? _a : getCompactChildrenState(category.id, selectedChildren, allChildIdsByCategoryId, {
        allowEmptyExclusions: true,
    });
    if (compactChildren) {
        return {
            id: category.id,
            children: compactChildren,
        };
    }
    return {
        id: category.id,
        children: selectedChildren,
    };
}));
const getStrategyMatrixQueryState = ({ allChildIdsByCategoryId = {}, allCategoryIds, catalogId, extendedFilter, projectId, selectedAttributes, selectedDisplayTable, }) => {
    const compactFilterState = getCompactFilterState(extendedFilter, allChildIdsByCategoryId, allCategoryIds);
    const extendedFilterViewState = compactFilterState !== null && compactFilterState !== void 0 ? compactFilterState : getExtendedFilterWithCompactChildren(extendedFilter, allChildIdsByCategoryId);
    return {
        [strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.ProjectId]: projectId,
        [strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.CatalogId]: catalogId,
        [strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.ExtendedFilter]: extendedFilterViewState,
        [strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.SelectedAttributes]: selectedAttributes,
        [strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.SelectedDisplayTable]: selectedDisplayTable,
    };
};
exports.getStrategyMatrixQueryState = getStrategyMatrixQueryState;
